import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'app-estadisticas-etiquetado-pd',
    templateUrl: './estadisticas-etiquetado-pd.component.html'
})
export class EstadisticasEtiquetadoPDComponent implements OnInit {

    public tipoEstadisticas = 1;
    public gridModal = false;
    public tituloGrid;
    public dataGrid;

    @Input() graficasEtiquetado;
    @Input() filtrado;

    @Output() showWarning = new EventEmitter<any>(true);

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _dataService: DataService,
        ) {
    }

    ngOnInit() {
        this.showKilosCampanyas();
    }

    public showKilosCampanyas() {
        //this.useDelay();
        this.tipoEstadisticas = 3;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: true,
            filtroDenominacion: true,
            filtroEtiquetador: false,
            tab3Etiquetado: true
        });
    }

    public showKilosEtiquetadorCampanyas() {
        //this.useDelay();
        this.tipoEstadisticas = 6;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: true,
            filtroEtiquetador: true,
            tab6Etiquetdao: true
        });
    }

    public exportarDataPDFExcel(graficasTab: any, service: string, paisId: number, denominacionId: number, etiquetadorId: any, tipo: string){
        if (this.graficasEtiquetado && graficasTab && graficasTab.length > 0) {
          var mimeType;
          let filters = {
            lsPaisId: paisId,
            lsDenominacionId: denominacionId,
            etiquetadorId: etiquetadorId,
            tipoArchivo: ""
          };

          if (tipo === 'excel') {
            filters.tipoArchivo = 'Excel';
            mimeType = 'data:application/vnd.ms-excel;base64,';
        } else if (tipo === 'pdf') {
            filters.tipoArchivo = 'Pdf';
            mimeType = 'data:application/pdf;base64,';
        } else {
            filters.tipoArchivo = 'csv';
            mimeType = 'data:text/csv;base64,';
        }

          this._spinnerService.showSpinner();
          this._dataService[service](filters).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
          }).then((resp) => {
            const downloadLink = document.createElement('a');
            downloadLink.href = mimeType + resp.base64Archivo;
            downloadLink.download = resp.nombreArchivo;
            downloadLink.click();
          });
        } else {
         //   this.showError = true;
         //   this.mensajes.push({ class: 'error', message: 'global.error.exportNoData' });
        }
    }

    public showGrid(paisId: any, pais: string, denominacionId: any, denominacion: string, etiquetadorId: any, etiquetador: string, service: string, title: string){
      this.tituloGrid = title;
      this.dataGrid = { paisId: paisId, pais: pais, denominacionId: denominacionId, denominacion: denominacion, etiquetadorId: etiquetadorId, etiquetador: etiquetador, service: service };
      this.gridModal = true;
    }

    public refresh(){
      this.gridModal = false;
    }
    // public delay(ms: number) {
    //     return new Promise( resolve => setTimeout(resolve, ms) );
    // }

    // public async useDelay() {
    //     if (this.filtrado) {
    //         this._spinnerService.showSpinner();
    //         await this.delay(1);
    //         this._spinnerService.hideSpinner();
    //     }
    // }

}
